import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import dateformat from 'dateformat';

import { Row, Col } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, LineChart, Line, Tooltip } from 'recharts';
import Measure from 'react-measure';

import CustomTooltipView from './tooltip/CustomTooltipView';

import _ from 'lodash';
import styles from './styles.module.scss'; 
import { localizedStrings } from 'src/localization/index.jsx';

class PageAnalyticsRowView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: null,
      activeIndex: 0,
      pages: [],
      pageCount: 0,
      chart: {
        width: 250,
        visible: false
      }
    }

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount(){
    var analytics = this.props.analytics;
    if(analytics && analytics.dataPoints){
      var pages = this.processAnalytics(analytics);
      
      var firstPage = null;
      if(pages.length > 0){
        firstPage = pages[0];
      }


      this.setState({
        pages: pages,
        totalPages: analytics.pageCount,
        activePage: firstPage
      })
    }
  }

  processAnalytics(analytics){
    if(!analytics || analytics.pageCount == 0 || analytics.dataPoints.length == 0){
      return [];
    }

    var pages = []
    for (var i = 1; i <= analytics.pageCount; i++) {
      let page = {
        index: i,
        totalTimeSpent: 0.0,
      }

      pages.push(page);
    }

    analytics.dataPoints.map((element) => {
      pages[element.index - 1] = element;
    })

    return pages;
  }

  render() {

if(this.props.renderWithin === "contact") {
      return this.renderContactPageAnalytics();
    }
    return this.renderConversationPageAnalytics();
  }

  renderConversationPageAnalytics() {
    return (
      <div className={styles.pageMetrics}>
        <div className={styles.noPadding}>
          {this.props.lastViewedDate &&
            <h5 className={styles.lastViewed}>{this.localizedCommons.last_viewed} {dateformat(this.props.lastViewedDate, 'dd mmm yyyy')}</h5>
          }
          {this.state.activePage != null &&
            <div className={this.props.className ? '' : styles.pageData}>
              <div className={this.props.className? this.props.className : styles.pageNumber}>{this.localizedCommons.page} #{this.padNumber(this.state.activePage.index, 2)}</div>
              <div className={styles.timeSpent}>{this.localizedCommons.time_spent}: {this.timeSpentValue(this.state.activePage.totalTimeSpent)}</div>
            </div>
          }
        </div>
        <div className={styles.noPadding}>
          {this.renderPageAnalytics()}
        </div>
      </div>
    );
  }

  renderContactPageAnalytics() {
    return (
      <div className={styles.contactPageMetrics}>
        <Col md={12} className={styles.noPaddingLeftRight}>
          {this.renderPageAnalytics()}
        </Col>
        <Col md={12} className={styles.noPadding}>
          {this.props.lastViewedDate &&
            <h5 className={styles.lastViewed}>{this.localizedCommons.last_viewed} {dateformat(this.props.lastViewedDate, 'dd mmm yyyy')}</h5>
          }
        </Col>
      </div>
    )
  }

  renderPageAnalytics(){
    var totalPages = this.state.totalPages;
    var width = totalPages * 13;
    
   if(width > this.state.chart.width){
      width = this.state.chart.width;
    }

    let activePage = this.state.activePage || {
      page: 0,
      avgTimeSpent: 0
    };
    
    return (
      <Measure bounds 
        onResize={(contentRect) => {
         this.setState({
            chart: {
              ...this.state.chart, 
              width: contentRect.bounds.width
            }
          })
        }}>

        {({measureRef}) =>
          <div ref={measureRef} id="page_analytics_chart">
            <BarChart className={styles.chart} width={width} height={this.props.chartHeight ? this.props.chartHeight : 50} data={this.state.pages}>
              <Bar
                ref={(element)=>{this.barChart = element;}}
                dataKey='totalTimeSpent'
                xAxisId='index'
                yAxisId='totalTimeSpent'
                fill='#a8a8a8'
                maxBarSize={10}
                minPointSize={5}
                onMouseEnter={this._handleChartMouseOver.bind(this)}
              >
              </Bar>
              {_.size(this.props.analytics.dataPoints) > 0 && 
                <Tooltip 
                  cursor={{ fill: '#dbdbdb' }}
                  content={(props) =>{
                    return this._renderTooltip(props);
                  }}
                />
              }
            </BarChart>
          </div>
        }
      </Measure>
    );
  }

  _renderTooltip(props){
    var {payload} = props;

    if(payload && payload.length > 0){
      var index = _.get(payload, '[0].payload.index', 0);
      var data = this.barChart.props.data[index - 1];

      return (
        <CustomTooltipView
          className={styles.tooltip}
          timeSpentLabel=""
          iconDimensions={{width: 120, height: 100}}
          activePage={data}
          preview={this.props.preview}
        />
      );
    }

    return false;
  }

  _handleChartMouseOver(data, index) {
    this.setState({
      activeIndex: index,
      activePage: data.payload
    })
  }

  padNumber(number=0, pad){
    number = Math.ceil(number);

    const length = pad-String(number).length+1;
    let padding = '';
    if(length>0){
      padding = Array(pad-String(number).length+1).join('0');
    }
    
    return padding + number;
  }

  timeSpentValue(timeSpent){
    let timeSpentValue = `~${this.padNumber(timeSpent,1)}s`;

    if(timeSpent >= 60){
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent/60),1)}m`;
    }

    return timeSpentValue;
  }
}

export default PageAnalyticsRowView;
